import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/checkIcon.svg'
import _imports_1 from '../assets/attachIcon.svg'
import _imports_2 from '../assets/organisationColoured.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-388d5c80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center w-full h-screen paddingContainer overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-auto mt-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-md text-center" }, "Welcome to CRYSTASURE !"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-black text-xs text-center mt-1" }, "To get the best experience, we recommend you to complete these onboarding steps")
], -1))
const _hoisted_3 = { class: "bg-white flex justify-between gap-5 border mt-3 border-lightgrey rounded infoContainer w-full p-5" }
const _hoisted_4 = { class: "w-1/5 relative h-full flex flex-col justify-between pr-1.5 overflow-y-auto scrollBarColour" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "w-2/6 z-50 flex justify-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-5 w-5 rounded-full bg-tickGreen flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-3.5 icon"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "w-2/6 z-50 flex justify-center"
}
const _hoisted_10 = { class: "h-6 w-6 rounded-full circleBackground flex justify-center items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["onMousemove"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "barLine absolute" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-l-0 border-lightgrey" }, null, -1))
const _hoisted_16 = { class: "w-4/5 h-full overflow-y-auto" }
const _hoisted_17 = {
  key: 0,
  class: "h-full w-full px-2 pb-2 pt-3"
}
const _hoisted_18 = { class: "row flex flex-row w-full" }
const _hoisted_19 = { class: "w-1/2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Organisation Legal Name", -1))
const _hoisted_21 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_22 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_23 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_24 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "The Organization Name already exists.", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "w-1/2 leftspacing" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Display Name", -1))
const _hoisted_29 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_30 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_31 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_32 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "Display Name already exists.", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "formcontainer flex flex-col" }
const _hoisted_36 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_37 = { class: "w-1/2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Website", -1))
const _hoisted_39 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_40 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_41 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_42 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_43 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "websiteUrl already exists.", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "w-1/2 leftspacing" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Organisation Key", -1))
const _hoisted_48 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_49 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_50 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_51 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_52 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "Organization Key already exists.", -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "formcontainer flex flex-col" }
const _hoisted_56 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_57 = { class: "w-1/2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Region", -1))
const _hoisted_59 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_60 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_61 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_62 = { class: "w-1/2 leftspacing" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Industry Sector", -1))
const _hoisted_64 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_65 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_66 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_67 = { class: "upperspacing" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Logo", -1))
const _hoisted_69 = ["disabled"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "upload",
  class: "float-left cursor-pointer flex text-black text-xs bg-lightgrey pl-2 pr-4 py-2"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "px-2"
  }),
  /*#__PURE__*/_createTextVNode("Attach")
], -1))
const _hoisted_71 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_72 = {
  key: 0,
  class: "error-text text-xs mx-2"
}
const _hoisted_73 = { class: "upperspacing" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Address line - 1", -1))
const _hoisted_75 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_76 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_77 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_78 = { class: "upperspacing" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Address line - 2", -1))
const _hoisted_80 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_81 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_82 = { class: "formcontainer flex flex-col" }
const _hoisted_83 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_84 = { class: "w-1/2" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "City", -1))
const _hoisted_86 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_87 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_88 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_89 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_90 = { class: "w-1/2 leftspacing" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "State", -1))
const _hoisted_92 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_93 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_94 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_95 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_96 = { class: "formcontainer flex flex-col" }
const _hoisted_97 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_98 = { class: "w-1/2" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Country", -1))
const _hoisted_100 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_101 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_102 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_103 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_104 = { class: "w-1/2 leftspacing" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Pincode", -1))
const _hoisted_106 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_107 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_108 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_109 = { class: "formcontainer flex flex-col" }
const _hoisted_110 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_111 = { class: "w-1/2" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Primary Contact Name", -1))
const _hoisted_113 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_114 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_115 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_116 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_117 = { class: "w-1/2 leftspacing" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Primary Contact Mail id", -1))
const _hoisted_119 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_120 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_121 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_122 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_123 = { class: "formcontainer flex flex-col" }
const _hoisted_124 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_125 = { class: "w-1/2" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Job Title", -1))
const _hoisted_127 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_128 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_129 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_130 = { class: "w-1/2 leftspacing" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Team", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "No departments Found", -1))
const _hoisted_133 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_134 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_135 = {
  key: 1,
  class: "p-2 h-full w-full"
}
const _hoisted_136 = { class: "overflow-y-scroll h-full w-full scrollBarColour" }
const _hoisted_137 = { class: "flex flex-wrap gap-2 p-2" }
const _hoisted_138 = { class: "flex justify-between items-center" }
const _hoisted_139 = { class: "flex justify-center p-2" }
const _hoisted_140 = { class: "flex justify-center items-center" }
const _hoisted_141 = ["value", "disabled"]
const _hoisted_142 = { class: "text-xs font-bold" }
const _hoisted_143 = {
  key: 2,
  class: "h-full w-full"
}
const _hoisted_144 = { class: "h-full w-full overflow-y-scroll scrollBarColour" }
const _hoisted_145 = { class: "h-full w-full pr-2" }
const _hoisted_146 = { key: 0 }
const _hoisted_147 = {
  key: 3,
  class: "h-full w-full p-2"
}
const _hoisted_148 = { class: "h-full w-full" }
const _hoisted_149 = { class: "flex flex-row gap-2 justify-between w-full h-full" }
const _hoisted_150 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-md" }, "All Systems", -1))
const _hoisted_152 = { class: "overflow-y-scroll h-full w-full mt-1 scrollBarColour" }
const _hoisted_153 = { class: "flex flex-row w-full h-full justify-center items-center" }
const _hoisted_154 = { class: "flex justify-center items-center w-full h-6 border categoryBackground border-greenBorder rounded-full" }
const _hoisted_155 = { class: "text-xs font-bold" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-b-0 border-lightgrey w-full mr-2.5" }, null, -1))
const _hoisted_157 = { class: "flex flex-wrap gap-2 py-2 pr-2" }
const _hoisted_158 = ["onClick"]
const _hoisted_159 = { class: "w-1/6 flex justify-center" }
const _hoisted_160 = { class: "flex justify-center items-center pr-1" }
const _hoisted_161 = ["src"]
const _hoisted_162 = { class: "w-5/6 text-xs" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-l-0 border-lightgrey h-full" }, null, -1))
const _hoisted_164 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-md" }, "Selected Systems", -1))
const _hoisted_166 = { class: "overflow-y-scroll h-full w-full scrollBarColour" }
const _hoisted_167 = { class: "flex flex-wrap gap-2 py-2 pr-2" }
const _hoisted_168 = ["onClick"]
const _hoisted_169 = { class: "w-1/6 flex justify-center" }
const _hoisted_170 = { class: "flex justify-center items-center pr-1" }
const _hoisted_171 = ["src"]
const _hoisted_172 = { class: "w-5/6 text-xs" }
const _hoisted_173 = {
  key: 4,
  class: "h-full w-full p-2"
}
const _hoisted_174 = { class: "h-full w-full" }
const _hoisted_175 = { class: "flex flex-row gap-2 justify-between w-full h-full" }
const _hoisted_176 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-md" }, "All Vendors", -1))
const _hoisted_178 = { class: "overflow-y-scroll h-full w-full mt-1 scrollBarColour" }
const _hoisted_179 = { class: "flex flex-row w-full h-full justify-center items-center" }
const _hoisted_180 = { class: "flex justify-center items-center w-full h-6 border categoryBackground border-greenBorder rounded-full" }
const _hoisted_181 = { class: "text-xs font-bold" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-b-0 border-lightgrey w-full mr-2.5" }, null, -1))
const _hoisted_183 = { class: "flex flex-wrap gap-2 py-2 pr-2" }
const _hoisted_184 = ["onClick"]
const _hoisted_185 = { class: "w-1/6 flex justify-center" }
const _hoisted_186 = { class: "flex justify-center items-center pr-1" }
const _hoisted_187 = ["src"]
const _hoisted_188 = { class: "w-5/6 text-xs" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-l-0 border-lightgrey h-full" }, null, -1))
const _hoisted_190 = { class: "w-1/2 flex flex-col gap-1" }
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-md" }, "Selected Vendors", -1))
const _hoisted_192 = { class: "overflow-y-scroll h-full w-full scrollBarColour" }
const _hoisted_193 = { class: "flex flex-wrap gap-2 py-2 pr-2" }
const _hoisted_194 = ["onClick"]
const _hoisted_195 = { class: "w-1/6 flex justify-center" }
const _hoisted_196 = { class: "flex justify-center items-center pr-1" }
const _hoisted_197 = ["src"]
const _hoisted_198 = { class: "w-5/6 text-xs" }
const _hoisted_199 = {
  key: 5,
  class: "h-full w-full p-2"
}
const _hoisted_200 = { class: "overflow-y-scroll h-full w-full scrollBarColour" }
const _hoisted_201 = { class: "flex flex-wrap gap-2 p-2" }
const _hoisted_202 = { class: "flex w-full h-full overflow-hidden" }
const _hoisted_203 = { class: "pl-2 pt-2" }
const _hoisted_204 = ["value", "disabled"]
const _hoisted_205 = { class: "p-2 w-full flex flex-col justify-between gap-1" }
const _hoisted_206 = { class: "flex justify-center h-16 w-14 mx-auto" }
const _hoisted_207 = ["src"]
const _hoisted_208 = {
  key: 1,
  src: _imports_2,
  class: "h-16"
}
const _hoisted_209 = { class: "flex justify-center w-full text-center text-xs font-bold" }
const _hoisted_210 = ["onMousemove"]
const _hoisted_211 = { key: 0 }
const _hoisted_212 = { class: "w-full flex items-end justify-end buttonContainer gap-4 pt-2.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_newTable = _resolveComponent("newTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onBoardTabs, (presentTab, myIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: myIndex,
            class: "flex flex-col items-center"
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.goToTabSelected(presentTab.id)),
              class: _normalizeClass([{
                                'border border-greenBorder z-50 bg-lightgrey cursor-pointer':_ctx.completedTabs.includes(presentTab),
                                'border border-primary z-50 bg-onBoardBlueBg cursor-pointer':_ctx.selectedTabIndex == presentTab.id,
                                'bg-white z-50 border border-lightgrey': presentTab.id > _ctx.selectedTabIndex
                            }, "flex w-full justify-center items-center rounded presentTabBoxHeight"])
            }, [
              (_ctx.completedTabs.includes(presentTab))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: presentTab.imageSrc,
                        class: "h-4 icon"
                      }, null, 8, _hoisted_11)
                    ])
                  ])),
              _createElementVNode("div", {
                class: _normalizeClass(["w-4/6 text-sm font-bold cusror-pointer", presentTab.displayName.length > 5? 'table-ellipsis': 'table-ellipsis']),
                onMousemove: ($event: any) => (_ctx.toolTip( $event, presentTab.displayName, 'text')),
                onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse()))
              }, _toDisplayString(presentTab.displayName), 43, _hoisted_12),
              (_ctx.toolTipActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progressNumbers, (num) => {
            return (_openBlock(), _createElementBlock("div", {
              key: num,
              class: _normalizeClass(["border border-lightgrey border-dashed h-1/5 mt-0.5", {'border-primary': _ctx.completedTabs.includes(_ctx.onBoardTabs[num])}])
            }, null, 2))
          }), 128))
        ])
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-full dataContainer", _ctx.selectedTabIndex == 2 ? '': 'border border-lightgrey rounded'])
        }, [
          (_ctx.selectedTabIndex == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", {
                  ref: "scrollContainerOrg",
                  onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                  class: "h-full w-full overflow-y-auto px-2 scrollBarColour"
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.onBoardObject.organizationName) = $event)),
                        placeholder: "Organisation Legal Name",
                        class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': (_ctx.v$.onBoardObject.organizationName.$error || _ctx.isDuplicateData.organizationName)
                                            }]),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.onBoardObject.organizationName.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.onBoardObject.organizationName,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.onBoardObject.organizationName.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_ctx.v$.onBoardObject.organizationName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Required"))
                              : (_ctx.v$.onBoardObject.organizationName.required && _ctx.v$.onBoardObject.organizationName.restrictCharacters60.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Character Limit exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isDuplicateData.organizationName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.onBoardObject.displayName) = $event)),
                        placeholder: "Display Name",
                        class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': (_ctx.v$.onBoardObject.displayName.$error || _ctx.isDuplicateData.displayName)
                                            }]),
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.onBoardObject.displayName.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.onBoardObject.displayName,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.onBoardObject.displayName.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_ctx.v$.onBoardObject.displayName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Required"))
                              : (_ctx.v$.onBoardObject.displayName.required && _ctx.v$.onBoardObject.displayName.restrictCharacters30.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Character Limit exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isDuplicateData.displayName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.onBoardObject.websiteUrl) = $event)),
                          placeholder: "Website",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.websiteUrl.$error || _ctx.isDuplicateData.websiteUrl)
                                                }]),
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                          onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.onBoardObject.websiteUrl.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.websiteUrl,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.websiteUrl.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              (_ctx.v$.onBoardObject.websiteUrl.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Required"))
                                : (_ctx.v$.onBoardObject.websiteUrl.required && _ctx.v$.onBoardObject.websiteUrl.restrictCharacters100.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Character Limit exceeded"))
                                  : (_ctx.v$.onBoardObject.websiteUrl.required &&  _ctx.v$.onBoardObject.websiteUrl.websiteValidate.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Invalid Website"))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isDuplicateData.websiteUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.onBoardObject.organizationKey) = $event)),
                          placeholder: "Organisation Key",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.organizationKey.$error || _ctx.isDuplicateData.organizationKey)
                                                }]),
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                          onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.onBoardObject.organizationKey.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.organizationKey,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.organizationKey.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              (_ctx.v$.onBoardObject.organizationKey.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Required"))
                                : (_ctx.v$.onBoardObject.organizationKey.required && _ctx.v$.onBoardObject.organizationKey.restrictCharacters5.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Character Limit exceeded"))
                                  : (_ctx.v$.onBoardObject.organizationKey.required && _ctx.v$.onBoardObject.organizationKey.textwithNumsOnly.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, "Invalid Key"))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isDuplicateData.organizationKey)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.onBoardObject.region) = $event)),
                          placeholder: "Region",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.region.$error)
                                                }]),
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                          onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.onBoardObject.region.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.region,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.region.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              (_ctx.v$.onBoardObject.region.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_60, "Required"))
                                : (_ctx.v$.onBoardObject.region.required && _ctx.v$.onBoardObject.region.restrictCharacters30.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, "Character Limit exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.onBoardObject.industrySector) = $event)),
                          placeholder: "Industry Sector",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.industrySector.$error)
                                                }]),
                          onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.onBoardObject.industrySector.$touch())),
                          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.industrySector,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.industrySector.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              (_ctx.v$.onBoardObject.industrySector.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Required"))
                                : (_ctx.v$.onBoardObject.industrySector.required && _ctx.v$.onBoardObject.industrySector.restrictCharacters30.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, "Character Limit exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-auto bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden mt-2", {'is-invalid': (_ctx.v$.onBoardObject.logoName.$error)}])
                      }, [
                        _createElementVNode("input", {
                          type: "file",
                          accept: ".jpg, .jpeg, .png, .svg",
                          ref: "fileInput",
                          class: "hidden",
                          id: "upload",
                          onChange: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.updateFileName($event)), ["stop"])),
                          disabled: _ctx.onBoardObject._id
                        }, null, 40, _hoisted_69),
                        _hoisted_70,
                        (!_ctx.onBoardObject._id && !_ctx.onBoardObject.logoName)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                              id: "fileNameSpan",
                              class: _normalizeClass(["items-center justify-between flex", (_ctx.onBoardObject.logoName)?'uploadedFileNameStyles':'placeholder-styles'])
                            }, _toDisplayString(_ctx.onBoardObject.logoName ? _ctx.onBoardObject.logoName.name : _ctx.placeholder), 3))
                          : (!_ctx.onBoardObject.logoName || !_ctx.onBoardObject.logoName.name)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                                id: "fileNameSpan",
                                class: _normalizeClass(["items-center justify-between flex", (_ctx.onBoardObject.logoName)?'uploadedFileNameStyles':'placeholder-styles'])
                              }, _toDisplayString(_ctx.onBoardObject.logoName ? _ctx.onBoardObject.logoName : _ctx.placeholder), 3))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                                id: "fileNameSpan",
                                class: _normalizeClass(["items-center justify-between flex", (_ctx.onBoardObject.logoName)?'uploadedFileNameStyles':'placeholder-styles'])
                              }, _toDisplayString(_ctx.onBoardObject.logoName ? _ctx.onBoardObject.logoName.name : _ctx.placeholder), 3))
                      ], 2),
                      (_ctx.v$.onBoardObject.logoName.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            (_ctx.v$.onBoardObject.logoName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, "Required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", null, [
                      _hoisted_74,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.onBoardObject.addressLineOne) = $event)),
                        placeholder: "Address line - 1",
                        class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': (_ctx.v$.onBoardObject.addressLineOne.$error)
                                            }]),
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                        onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.onBoardObject.addressLineOne.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.onBoardObject.addressLineOne,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.onBoardObject.addressLineOne.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            (_ctx.v$.onBoardObject.addressLineOne.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_76, "Required"))
                              : (_ctx.v$.onBoardObject.addressLineOne.required && _ctx.v$.onBoardObject.addressLineOne.restrictCharacters300.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, "Character Limit exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", null, [
                      _hoisted_79,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.onBoardObject.addressLineTwo) = $event)),
                        placeholder: "Address line - 2",
                        class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': (_ctx.v$.onBoardObject.addressLineTwo.$error)
                                            }]),
                        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                        onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.v$.onBoardObject.addressLineTwo.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.onBoardObject.addressLineTwo,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.onBoardObject.addressLineTwo.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            (_ctx.v$.onBoardObject.addressLineTwo.restrictCharacters300.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, "Character Limit exceeded"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.onBoardObject.city) = $event)),
                          placeholder: "City",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.city.$error)
                                                }]),
                          onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.v$.onBoardObject.city.$touch())),
                          onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.city,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.city.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              (_ctx.v$.onBoardObject.city.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, "Required"))
                                : _createCommentVNode("", true),
                              (_ctx.v$.onBoardObject.city.restrictCharacters30.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, "Character Limit exceeded"))
                                : (_ctx.v$.onBoardObject.city.required && _ctx.v$.onBoardObject.city.textOnly.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, "Only letters and spaces are allowed."))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _hoisted_91,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.onBoardObject.state) = $event)),
                          onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.v$.onBoardObject.state.$touch())),
                          onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                          placeholder: "State",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.state.$error)
                                                }])
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.state,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.state.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                              (_ctx.v$.onBoardObject.state.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_93, "Required"))
                                : _createCommentVNode("", true),
                              (_ctx.v$.onBoardObject.state.restrictCharacters30.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_94, "Character Limit exceeded"))
                                : (_ctx.v$.onBoardObject.state.required && _ctx.v$.onBoardObject.state.textOnly.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, "Only letters and spaces are allowed."))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.onBoardObject.country) = $event)),
                          onInput: _cache[36] || (_cache[36] = ($event: any) => (_ctx.v$.onBoardObject.country.$touch())),
                          onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                          placeholder: "Country",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.country.$error)
                                                }])
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.country,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.country.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              (_ctx.v$.onBoardObject.country.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, "Required"))
                                : _createCommentVNode("", true),
                              (_ctx.v$.onBoardObject.country.restrictCharacters30.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_102, "Character Limit exceeded"))
                                : (_ctx.v$.onBoardObject.country.required && _ctx.v$.onBoardObject.country.textOnly.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_103, "Only letters and spaces are allowed."))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _hoisted_105,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.onBoardObject.pinCode) = $event)),
                          type: "number",
                          placeholder: "Pincode",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.pinCode.$error)
                                                }]),
                          onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args))),
                          onInput: _cache[40] || (_cache[40] = ($event: any) => (_ctx.v$.onBoardObject.pinCode.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.pinCode,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.pinCode.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                              (_ctx.v$.onBoardObject.pinCode.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_107, "Required"))
                                : (_ctx.v$.onBoardObject.pinCode.required && _ctx.v$.onBoardObject.pinCode.pin.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, "Pin Code is Invalid"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", _hoisted_111, [
                        _hoisted_112,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.onBoardObject.primaryContactName) = $event)),
                          placeholder: "Primary Contact Name",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.primaryContactName.$error)
                                                }]),
                          onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.v$.onBoardObject.primaryContactName.$touch())),
                          onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.primaryContactName,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.primaryContactName.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                              (_ctx.v$.onBoardObject.primaryContactName.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_114, "Required"))
                                : (_ctx.v$.onBoardObject.primaryContactName.required && _ctx.v$.onBoardObject.primaryContactName.restrictCharacters30.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, "Character Limit exceeded"))
                                  : (_ctx.v$.onBoardObject.primaryContactName.required && _ctx.v$.onBoardObject.primaryContactName.textOnly.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, "Only letters and spaces are allowed."))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        _hoisted_118,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.onBoardObject.primaryContactEmail) = $event)),
                          placeholder: "Primary Contact Mail id",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.primaryContactEmail.$error)
                                                }]),
                          onInput: _cache[45] || (_cache[45] = ($event: any) => (_ctx.v$.onBoardObject.primaryContactEmail.$touch())),
                          onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.primaryContactEmail,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.primaryContactEmail.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                              (_ctx.v$.onBoardObject.primaryContactEmail.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_120, "Required"))
                                : (_ctx.v$.onBoardObject.primaryContactEmail.required && _ctx.v$.onBoardObject.primaryContactEmail.email.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, "Email is Invalid"))
                                  : (_ctx.v$.onBoardObject.primaryContactEmail.required && _ctx.v$.onBoardObject.primaryContactEmail.restrictCharacters50.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, "Character Limit exceeded"))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("div", _hoisted_125, [
                        _hoisted_126,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.onBoardObject.jobTitle) = $event)),
                          placeholder: "Job Title",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.jobTitle.$error)
                                                }]),
                          onInput: _cache[48] || (_cache[48] = ($event: any) => (_ctx.v$.onBoardObject.jobTitle.$touch())),
                          onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.jobTitle,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.jobTitle.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                              (_ctx.v$.onBoardObject.jobTitle.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_128, "Required"))
                                : (_ctx.v$.onBoardObject.jobTitle.required && _ctx.v$.onBoardObject.jobTitle.restrictCharacters30.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_129, "Character Limit exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_130, [
                        _hoisted_131,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.onBoardObject.departments,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.onBoardObject.departments) = $event)),
                          options: _ctx.teamsOptions,
                          showNoOptions: false,
                          onSearchChange: _ctx.asyncdepartmentDisplayFind,
                          multiple: false,
                          label: "label",
                          "track-by": "value",
                          searchable: true,
                          "close-on-select": true,
                          "show-labels": false,
                          "hide-selected": true,
                          placeholder: "Team",
                          "open-direction": "top",
                          class: _normalizeClass(["custom-multiselect userSelect mt-2", {
                                                    'is-invalidmultiselect': _ctx.v$.onBoardObject.departments.$error,
                                                    'has-options': _ctx.teamsOptions && _ctx.teamsOptions.length > 0,
                                                    'no-options': !_ctx.teamsOptions.length,
                                                }]),
                          onClick: _ctx.handleOrgFormScroll
                        }, {
                          noResult: _withCtx(() => [
                            _hoisted_132
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onSearchChange", "onClick", "class"]),
                        (_ctx.v$.onBoardObject.departments.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                              (_ctx.v$.onBoardObject.departments.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_134, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ], 512)
              ]))
            : (_ctx.selectedTabIndex == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamsList, (team) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: team.id,
                          class: "flex items-center overflow-hidden teamWidth h-10 border border-lightgrey rounded cursor-pointer"
                        }, [
                          _createElementVNode("div", _hoisted_138, [
                            _createElementVNode("div", _hoisted_139, [
                              _createElementVNode("div", _hoisted_140, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.selectedTeamList) = $event)),
                                  value: team,
                                  type: "checkbox",
                                  class: "checkBoxStyles",
                                  disabled: _ctx.isDepartmentTeam(team)
                                }, null, 8, _hoisted_141), [
                                  [_vModelCheckbox, _ctx.selectedTeamList]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_142, _toDisplayString(team.displayName), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : (_ctx.selectedTabIndex == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                    _createElementVNode("div", _hoisted_144, [
                      _createElementVNode("div", _hoisted_145, [
                        _createVNode(_component_newTable, {
                          tableRowData: _ctx.activitiesList,
                          headersData: _ctx.headers,
                          openPopup: false,
                          navigate: false,
                          buttonType: _ctx.buttonType,
                          dotsLoading: _ctx.spinnerLoading
                        }, null, 8, ["tableRowData", "headersData", "buttonType", "dotsLoading"]),
                        (_ctx.toolTipActive)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_ctx.selectedTabIndex == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("div", _hoisted_149, [
                          _createElementVNode("div", _hoisted_150, [
                            _hoisted_151,
                            _withDirectives(_createElementVNode("input", {
                              class: "inputboxstyling placeholderImg",
                              type: "text",
                              placeholder: "Search Option for All Systems",
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.searchTerm) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.searchTerm]
                            ]),
                            _createElementVNode("div", _hoisted_152, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedSystemsCollectionArray, (systems, category) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: category,
                                  class: "mt-1"
                                }, [
                                  _createElementVNode("div", _hoisted_153, [
                                    _createElementVNode("div", _hoisted_154, [
                                      _createElementVNode("h1", _hoisted_155, _toDisplayString(category), 1)
                                    ]),
                                    _hoisted_156
                                  ]),
                                  _createElementVNode("div", _hoisted_157, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systems, (system) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: system._id,
                                        class: "flex justify-center items-center p-1 systemWidth h-8 border border-lightgrey rounded cursor-pointer",
                                        onClick: ($event: any) => (_ctx.groupedSelectedSystems(system))
                                      }, [
                                        _createElementVNode("div", _hoisted_159, [
                                          _createElementVNode("div", _hoisted_160, [
                                            _createElementVNode("img", {
                                              src: system.systemSrc,
                                              alt: "System Image",
                                              class: "w-5 h-5"
                                            }, null, 8, _hoisted_161)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_162, _toDisplayString(system.systemName), 1)
                                      ], 8, _hoisted_158))
                                    }), 128))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _hoisted_163,
                          _createElementVNode("div", _hoisted_164, [
                            _hoisted_165,
                            _withDirectives(_createElementVNode("input", {
                              class: "inputboxstyling placeholderImg",
                              type: "text",
                              placeholder: "Search Option for Selected Systems",
                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.searchSelectedSystem) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.searchSelectedSystem]
                            ]),
                            _createElementVNode("div", _hoisted_166, [
                              _createElementVNode("div", _hoisted_167, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSystemsCollectionArray, (system) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: system._id,
                                    class: "flex justify-center items-center p-1 systemWidth h-8 border border-lightgrey rounded cursor-pointer",
                                    onClick: ($event: any) => (_ctx.groupedDeselectedSystems(system))
                                  }, [
                                    _createElementVNode("div", _hoisted_169, [
                                      _createElementVNode("div", _hoisted_170, [
                                        _createElementVNode("img", {
                                          src: system.systemSrc,
                                          alt: "System Image",
                                          class: "w-5 h-5"
                                        }, null, 8, _hoisted_171)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_172, _toDisplayString(system.systemName), 1)
                                  ], 8, _hoisted_168))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : (_ctx.selectedTabIndex == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                        _createElementVNode("div", _hoisted_174, [
                          _createElementVNode("div", _hoisted_175, [
                            _createElementVNode("div", _hoisted_176, [
                              _hoisted_177,
                              _withDirectives(_createElementVNode("input", {
                                class: "inputboxstyling placeholderImg",
                                type: "text",
                                placeholder: "Search Option for All Vendors",
                                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.searchVendor) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.searchVendor]
                              ]),
                              _createElementVNode("div", _hoisted_178, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedVendorsCollectionArray, (vendors, category) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: category,
                                    class: "mt-1"
                                  }, [
                                    _createElementVNode("div", _hoisted_179, [
                                      _createElementVNode("div", _hoisted_180, [
                                        _createElementVNode("h1", _hoisted_181, _toDisplayString(category), 1)
                                      ]),
                                      _hoisted_182
                                    ]),
                                    _createElementVNode("div", _hoisted_183, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vendors, (vendor) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: vendor._id,
                                          class: "flex justify-center items-center p-1 systemWidth h-8 border border-lightgrey rounded cursor-pointer",
                                          onClick: ($event: any) => (_ctx.groupedSelectedVendors(vendor))
                                        }, [
                                          _createElementVNode("div", _hoisted_185, [
                                            _createElementVNode("div", _hoisted_186, [
                                              _createElementVNode("img", {
                                                src: vendor.vendorSrc,
                                                alt: "Vendor Image",
                                                class: "w-5 h-5"
                                              }, null, 8, _hoisted_187)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_188, _toDisplayString(vendor.vendorName), 1)
                                        ], 8, _hoisted_184))
                                      }), 128))
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _hoisted_189,
                            _createElementVNode("div", _hoisted_190, [
                              _hoisted_191,
                              _withDirectives(_createElementVNode("input", {
                                class: "inputboxstyling placeholderImg",
                                type: "text",
                                placeholder: "Search Option for Selected Vendors",
                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.searchSelectedVendors) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.searchSelectedVendors]
                              ]),
                              _createElementVNode("div", _hoisted_192, [
                                _createElementVNode("div", _hoisted_193, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedVendorsCollectionArray, (vendor) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: vendor._id,
                                      class: _normalizeClass(["flex justify-center items-center p-1 systemWidth h-8 border border-lightgrey rounded cursor-pointer", vendor.systemIds != undefined ?'bg-lightgrey' : '']),
                                      onClick: ($event: any) => (_ctx.groupedDeselectedVendors(vendor))
                                    }, [
                                      _createElementVNode("div", _hoisted_195, [
                                        _createElementVNode("div", _hoisted_196, [
                                          _createElementVNode("img", {
                                            src: vendor.vendorSrc,
                                            alt: "Vendors Image",
                                            class: "w-5 h-5"
                                          }, null, 8, _hoisted_197)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_198, _toDisplayString(vendor.vendorName), 1)
                                    ], 10, _hoisted_194))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_ctx.selectedTabIndex == 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                          _createElementVNode("div", _hoisted_200, [
                            _createElementVNode("div", _hoisted_201, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frameWorkList, (framework) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  key: framework.id,
                                  class: "teamWidth h-24 border border-lightgrey rounded cursor-pointer"
                                }, [
                                  _createElementVNode("div", _hoisted_202, [
                                    _createElementVNode("div", _hoisted_203, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.selectedFrameWorks) = $event)),
                                        value: framework,
                                        type: "checkbox",
                                        disabled: framework.frameworkName == 'InternalControls',
                                        class: "checkBoxStyles"
                                      }, null, 8, _hoisted_204), [
                                        [_vModelCheckbox, _ctx.selectedFrameWorks]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_205, [
                                      _createElementVNode("div", _hoisted_206, [
                                        (framework.imageSrc != '')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: framework.imageSrc,
                                              alt: "framework Image"
                                            }, null, 8, _hoisted_207))
                                          : (_openBlock(), _createElementBlock("img", _hoisted_208))
                                      ]),
                                      _createElementVNode("div", _hoisted_209, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-1/2", framework.frameworkName.length > 5? 'table-ellipsis': 'table-ellipsis']),
                                          onMousemove: ($event: any) => (_ctx.toolTip( $event, framework.frameworkName, 'text')),
                                          onMouseout: _cache[58] || (_cache[58] = ($event: any) => (_ctx.doFalse()))
                                        }, _toDisplayString(framework.frameworkName), 43, _hoisted_210)
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]),
                            (_ctx.toolTipActive)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                  _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_212, [
          _createElementVNode("button", {
            onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.goBackTab())),
            class: "btnprimary h-7 w-16 flex justify-center items-center taskEditButtons"
          }, "Back"),
          _createElementVNode("button", {
            onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.goFrontTab())),
            class: "btnprimary nextButton h-7 w-16 flex justify-center items-center"
          }, "Next")
        ])
      ])
    ])
  ]))
}